import type { PayloadAction} from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import type {
  TripListRead,
} from 'src/common/external/bambi-api/tripsApi';

export interface IPricingState {
  selectedTrip: TripRead | TripListRead | null;
  tripPriceSummaryModalOpen: boolean;
  pricingSearchTerm: string;
  selectedPayers: string[];
  selectedSpaceTypes: string[];
  selectedServiceTypes: string[];
}

export const initialPricingState: IPricingState = {
  selectedTrip: null,
  tripPriceSummaryModalOpen: false,
  pricingSearchTerm: '',
  selectedPayers: [],
  selectedSpaceTypes: [],
  selectedServiceTypes: [],
};

export const pricingSlice = createSlice({
  name: 'pricing',
  initialState: initialPricingState,
  reducers: {
    onPriceSummaryModalClose: (state) => {
      state.selectedTrip = null;
      state.tripPriceSummaryModalOpen = false;
    },
    onPriceSummaryModalOpen: (
      state,
      action: PayloadAction<TripRead | TripListRead>
    ) => {
      state.selectedTrip = action.payload;
      state.tripPriceSummaryModalOpen = true;
    },
    onClearFilters: (state) => {
      state.selectedPayers = [];
      state.selectedSpaceTypes = [];
      state.selectedServiceTypes = [];
    },
    setPricingSearchTerm: (state, action: PayloadAction<string>) => {
      state.pricingSearchTerm = action.payload;
    },
    setSelectedPayers: (state, action: PayloadAction<string[]>) => {
      state.selectedPayers = action.payload;
    },
    setSelectedSpaceTypes: (state, action: PayloadAction<string[]>) => {
      state.selectedSpaceTypes = action.payload;
    },
    setSelectedServiceTypes: (state, action: PayloadAction<string[]>) => {
      state.selectedServiceTypes = action.payload;
    },
  },
});

export const {
  onPriceSummaryModalClose,
  onPriceSummaryModalOpen,
  onClearFilters,
  setPricingSearchTerm,
  setSelectedPayers,
  setSelectedSpaceTypes,
  setSelectedServiceTypes,
} = pricingSlice.actions;
